/**
 * Pages that are Nami already: `/chat` (history) and Home, which holds the
 * conversation inline. The pill and docked panel step aside there.
 */
export function isChatPath(pathname: string): boolean {
  return (
    pathname === '/chat' ||
    pathname.startsWith('/chat/') ||
    pathname === '/home' ||
    pathname.startsWith('/home/')
  );
}
